import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { BigBagInterface } from './type';
import { BigBagRepository } from './repository';
import { useToast } from 'primevue/usetoast'
import { useUsers } from '@/features/users/controller'


export const useBigBags = defineStore('bigbags', () => {

    const $userStore = useUsers()
    const bigbagRepository = new BigBagRepository();
    const bigBags = ref<BigBagInterface[]>([])
    const toast = useToast()

    const getBigBags = async () => {
        let userId = null
        if ($userStore.selectedUserForShop && $userStore.loggedUser && ($userStore.loggedUser.type === 'administrator' || $userStore.loggedUser.type === 'storekeeper') && typeof $userStore.selectedUserForShop === 'object') {
            userId = $userStore.selectedUserForShop.id
        } else if ($userStore.loggedUser) {
            userId = $userStore.loggedUser.id
        }
        const res = await bigbagRepository.getBigBags({ userId })
        if (!res.error) {
            bigBags.value = res.data.big_bags
        }
        return res
    }

    return {
        bigBags,
        getBigBags,
    }

}, {
    persist: {
        paths: [],
    },
})